import { Component } from '@angular/core';
import { COMMIT_SHORT_SHA, VERSION } from '../version';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  VERSION = VERSION;

  COMMIT_SHORT_SHA = COMMIT_SHORT_SHA;

}
